import { render } from "./SPRINT_RETROSPECTIVE.vue?vue&type=template&id=10da796f&ts=true"
import script from "./SPRINT_RETROSPECTIVE.vue?vue&type=script&lang=ts"
export * from "./SPRINT_RETROSPECTIVE.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__